import * as React from 'react';
import { styled } from '@mui/material/styles';
import Tooltip, { TooltipProps, tooltipClasses } from '@mui/material/Tooltip';
import { Typography } from '@mui/material';

const LightTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.common.white,
    color: 'rgba(0, 0, 0, 0.87)',
    boxShadow: theme.shadows[1],
    fontSize: 11,
  },
}));

interface AppTooltipProps {
  color?: string;
  text?: string;
  // style?: Object;
  // onClick?: any;
  // Icon?: React.ReactElement;
}

const AppTooltip: React.FC<AppTooltipProps> = ({ color, text }) => {
  return (
    <div>
      <LightTooltip title={text} placement="bottom-start">
        <Typography sx={{ color: color }}>0 Elo</Typography>
      </LightTooltip>
    </div>
  );
};
export default AppTooltip;
